import script from "./gbhome.vue?vue&type=script&setup=true&lang=js"
export * from "./gbhome.vue?vue&type=script&setup=true&lang=js"

import "./gbhome.vue?vue&type=style&index=0&id=c33d6516&scoped=true&lang=less"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c33d6516"]])

export default __exports__